(ns io.daskul.tutorial.webapp.domain.auth.change-password-subs
  "Subscriptions for change-password state."
  (:require
   [re-frame.core :as rf]))

(rf/reg-sub
 ::loading?
 (fn [db _]
   (get-in db [:change-password :loading?] false)))

(rf/reg-sub
 ::error
 (fn [db _]
   (get-in db [:change-password :error])))

(rf/reg-sub
 ::success?
 (fn [db _]
   (get-in db [:change-password :success?] false)))
